import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

export default new VueRouter({
    mode:'history',
    routes: [
        {
            path: '/pay.html',
            name: 'dcPay',
            component: ()=>import('@/views/pay')
        },
        {
            path: '/payResult.html',
            name: 'dcPayResult',
            component: ()=>import('@/views/payResult')
        },
        {
            path: '/order.html',
            name: 'order',
            component: ()=>import('@/views/order')
        },
        { //移动端
            path: '/payMobile.html',
            name: 'payMobile',
            component: ()=>import('@/views/mobile/payMobile')
        },
        { //移动端
            path: '/payResultMobile.html',
            name: 'payResultMobile',
            component: ()=>import('@/views/mobile/payResultMobile')
        },
    ]
})
